import fetch from '../utils/fetch'

// 獲取部門列表
export function getWorkwechat (params = {}) {
  return fetch({
    url: '/workwechat/report',
    method: 'get',
    params: params
  })
}

// 獲取部門成員
export function getMemberByClub (departmentId) {
  return fetch({
    url: `/workwechat/report/${departmentId}`,
    method: 'get'
  })
}

// 同步部門資訊到店鋪
export function syncClubToStore (data) {
  return fetch({
    url: '/workwechat/report/syncDistributor',
    method: 'post',
    params: data
  })
}

// 同步成員到導購員
export function syncMemberToGuide (data) {
  return fetch({
    url: '/workwechat/report/syncSalesperson',
    method: 'post',
    params: data
  })
}
